export default "__VITE_ASSET__I_jcEmnb_lljugSlrGh9KA__ 480w, __VITE_ASSET__FYSGGDqEzeMCxBJJaNSurg__ 768w, __VITE_ASSET__UtSd2wWiGs0Sim15oE6Xxg__ 1200w";